import React from 'react';
import '../styles/PreguntasFrecuentes.css';

const PreguntasFrecuentes: React.FC = () => {
  const faqs = [
    {
      pregunta: '¿Cuánto tarda el envío?',
      respuesta:
        'Los envíos dentro de Chile tardan entre 2 y 5 días hábiles, dependiendo de la región. Recibirás un correo con el número de seguimiento una vez despachado.',
    },
    {
      pregunta: '¿El shaker tiene garantía?',
      respuesta:
        'Sí, todos nuestros productos tienen garantía de 3 meses por defectos de fábrica. Escríbenos si notas algo inusual en tu producto.',
    },
    {
      pregunta: '¿Puedo cambiar el color después de comprar?',
      respuesta:
        'Si tu pedido aún no ha sido enviado, contáctanos por correo o WhatsApp y te ayudaremos con el cambio de color sin costo adicional.',
    },
    {
      pregunta: '¿El shaker es recargable?',
      respuesta:
        'Sí, cuenta con carga USB-C. Solo debes conectar el cable incluido para recargar la batería integrada.',
    },
  ];

  return (
    <section className="pagina-contenedor">
      <h2 className="titulo-seccion">Preguntas Frecuentes</h2>
      <div className="faq-lista">
        {faqs.map((item, i) => (
          <div key={i} className="faq-item">
            <h3 className="faq-pregunta">{item.pregunta}</h3>
            <p className="faq-respuesta">{item.respuesta}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PreguntasFrecuentes;
